<template>
  <div class="home">
    <HomeBanner/>
    <div class="coverage-results" v-if="success">
      <h2>Thank you {{ form.name }}</h2>
      <v-container id="vuma-interested" class="py-10">
        We have no immediate plans to come to your area but should that change we will notify you.
        <br><br>
        Encourage your neighbours to visit our website to show their interest too.
      </v-container>
    </div>
    <div class="coverage-results" v-if="!success">
      <h2>{{ coverageStatus }}</h2>
      <v-container id="vuma-interested" class="py-10">
        <div class="your-addr-wrap">
          <v-row>
            <v-col class="text-center">
              <h3 class="addr-title">Your Address:</h3>
              <h4 class="actual-addr">{{ coverage_address }}</h4>
              <p>It's important that this is your correct address.</p>
              <v-btn rounded dark to="/" class="change-addr-btn move-to" data-section="vm-coverage-wrap">
                Change Address
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <v-radio-group v-model="radioGroup" row class="apartment-radio">
          <v-radio
            v-for="(n, index) in complexCheck"
            :key="index"
            :label="n.label"
            :value="n.value"
            @change="showApartment(n.value)"
            color="#ff008e"
          ></v-radio>
        </v-radio-group>
        <div v-if="!hasAddress && !showingApartment">
          <v-row>
            <v-col class="col-md-4 form-group" :class="{ 'form-group--error': $v.form.street_number.$error }">
              <v-text-field
                label="Street Number"
                required
                v-model.trim="$v.form.street_number.$model"
              ></v-text-field>
              <div class="error" v-if="!$v.form.street_number.required">Field is required</div>
            </v-col>
            <v-col class="col-md-8 form-group" :class="{ 'form-group--error': $v.form.street_name.$error }">
              <v-text-field
                label="Street Name"
                required
                v-model.trim="$v.form.street_name.$model"
              ></v-text-field>
              <div class="error" v-if="!$v.form.street_name.required">Field is required</div>
            </v-col>
          </v-row>
        </div>
        <v-row v-if="showingApartment">
          <v-col class="col-md-4 form-group" :class="{ 'form-group--error': $v.form.unit_number.$error }">
            <v-text-field
              label="Unit Number"
              required
              v-model.trim="$v.form.unit_number.$model"
            ></v-text-field>
            <div class="error" v-if="!$v.form.unit_number.required">Field is required</div>
          </v-col>
          <v-col class="col-md-8 form-group" :class="{ 'form-group--error': $v.form.apartment.$error }">
            <v-text-field
              label="Apartment or Complex"
              required
              v-model.trim="$v.form.apartment.$model"
            ></v-text-field>
            <div class="error" v-if="!$v.form.apartment.required">Field is required</div>
          </v-col>
        </v-row>
        <h3 class="mt-5">Enter your details to show your interest.</h3>
        <p>We will not share this information with anyone and will only use it to contact you regarding your fibre
          journey.</p>
        <v-row>
          <v-col class="col-10 col-sm-6 form-group" :class="{ 'form-group--error': $v.form.name.$error }">
            <v-text-field
              label="Name"
              required
              v-model.trim="$v.form.name.$model"
            ></v-text-field>
            <div class="error" v-if="!$v.form.name.required">Field is required</div>
            <div class="error" v-if="!$v.form.name.minLength">Name must have at least
              {{ $v.form.name.$params.minLength.min }} letters.
            </div>
          </v-col>
          <v-col class="col-10 col-sm-6 form-group" :class="{ 'form-group--error': $v.form.surname.$error }">
            <v-text-field
              label="Surname"
              required
              v-model.trim="$v.form.surname.$model"
            ></v-text-field>
            <div class="error" v-if="!$v.form.surname.required">Field is required</div>
            <div class="error" v-if="!$v.form.surname.minLength">Name must have at least
              {{ $v.form.surname.$params.minLength.min }}letters.
            </div>
          </v-col>
          <v-col class="col-10 col-sm-6 form-group" :class="{ 'form-group--error': $v.form.cellphone.$error }">
            <v-text-field
              label="Cellphone"
              required
              v-model.trim="$v.form.cellphone.$model"
            ></v-text-field>
            <div class="error" v-if="!$v.form.cellphone.required">Field is required</div>
          </v-col>
          <v-col class="col-10 col-sm-6 form-group" :class="{ 'form-group--error': $v.form.email.$error }">
            <v-text-field
              label="Email"
              required
              v-model.trim="$v.form.email.$model"
            ></v-text-field>
            <div class="error" v-if="!$v.form.email.required">Field is required</div>
            <div class="error" v-if="!$v.form.email.email">Please enter a valid email.</div>
          </v-col>
          <v-col class="col-12">
            <v-checkbox v-model="getUpdates" color="#ff008e">
              <template v-slot:label>
                <div>
                  Get the latest build
                  <v-tooltip top max-width="290px">
                    <template v-slot:activator="{ on }">
                      <a
                        target="_blank"
                        href="#"
                        @click.stop
                        v-on="on"
                      >
                        updates
                      </a>
                    </template>
                    Stay in contact with VUMA and receive construction updates and info relevant to you.
                  </v-tooltip>
                  from Vumatel
                </div>
              </template>
            </v-checkbox>
            <v-checkbox v-model="championCheck" class="mt-0" color="#ff008e">
              <template v-slot:label>
                <div>
                  Become a
                  <v-tooltip top max-width="290px">
                    <template v-slot:activator="{ on }">
                      <a
                        target="_blank"
                        href="#"
                        @click.stop
                        v-on="on"
                      >
                        VUMA area Champion
                      </a>
                    </template>
                    Becoming a VUMA area Champion will ensure that you are kept up to date with the latest news,
                    infomation and progress reports in your area. You will also be expected to help drive the project
                    from a customer point of view and engage with your community throughout the project
                  </v-tooltip>
                </div>
              </template>
            </v-checkbox>
            <v-checkbox v-model="marketingCheck" class="mt-0" color="#ff008e">
              <template v-slot:label>
                <div>
                  Get marketing info.
                    <v-tooltip top max-width="290px">
                      <template v-slot:activator="{ on }">
                        <a
                          target="_blank"
                          href="https://cdn.vumatel.co.za/files/vumatel-privacy-policy.pdf"
                          @click.stop
                          v-on="on"
                        >
                          Privacy Policy
                        </a>
                      </template>
                        View Vumatel's privacy policy here.
                    </v-tooltip>
                </div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col>
            <v-btn @click.prevent="submitSMI()" rounded dark>
              I'm interested
            </v-btn>
          </v-col>
        </v-row>
        <v-dialog v-model="dialog" max-width="290">
          <v-card>
            <v-card-text class="text-center pink-primary" style="padding: 16px !important;">
              <v-progress-circular :size="70" indeterminate class="primary--text"/>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import HomeBanner from '@/components/Home/Banner'

import {
  required,
  requiredIf,
  minLength,
  email,
} from 'vuelidate/lib/validators'

export default {
  name: 'Home',
  components: {
    HomeBanner,
  },
  data: () => ({
    coverageStatus: 'Vuma fibre not available',
    showPages: false,
    whichProduct: '',
    coverage_address: '',
    hasAddress: false,
    getUpdates: true,
    championCheck: false,
    marketingCheck: false,
    tab: null,
    complexCheck: [
      {
        label: 'Free Standing House',
        value: 'free_standing',
      },
      {
        label: 'Apartment or Complex',
        value: 'apartment',
      },
    ],
    radioGroup: null,
    showingApartment: false,
    form: {
      name: '',
      surname: '',
      cellphone: '',
      email: '',
      street_number: '',
      street_name: '',
      unit_number: null,
      apartment: null,
    },
    apiKey: 'sLE0ikW3xojPFXsDHYW460phH2HhvKq0',
    lat: null,
    long: null,
    city: null,
    suburb: null,
    postal_code: null,
    place_id: null,
    success: false,
    dialog: false,
  }),
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(4),
      },
      surname: {
        required,
        minLength: minLength(4),
      },
      cellphone: { required },
      email: { required, email },
      street_number: {
        required: requiredIf(function () {
          return !this.hasAddress
        }),
      },
      street_name: {
        required: requiredIf(function () {
          return !this.hasAddress
        }),
      },
      unit_number: {
        required: requiredIf(function () {
          return this.showingApartment
        }),
      },
      apartment: {
        required: requiredIf(function () {
          return this.showingApartment
        }),
      },
    },
  },
  async mounted () {
    try {
      if (this.$cookies.isKey('coverage_status')) {
        this.coverageStatus = this.$cookies.get('coverage_status')
      }
      if (this.$cookies.isKey('user_address')) {
        let data = this.$cookies.get('user_address')
        this.lat = this.$cookies.get('lat')
        this.long = this.$cookies.get('long')
        this.city = this.$cookies.get('smi_city')
        this.suburb = this.$cookies.get('smi_suburb')
        this.postal_code = this.$cookies.get('smi_postal_code')
        this.place_id = this.$cookies.get('smi_place_id')
        this.street_name = this.$cookies.get('smi_street_name')
        this.street_number = this.$cookies.get('smi_street_number')

        if (this.street_name && this.street_number) {
          this.hasAddress = true
        }

        this.coverage_address = data

        $('html, body').stop().animate({
          'scrollTop': $('.coverage-results').offset().top - 130,
        }, 500, 'swing')
      }
    } catch (error) {
      console.error(error)
    }
    this.scrollToCoverage()
  },
  methods: {
    showmenu (event) {
      event.preventDefault()
      $('.vuma-menu').addClass('menu-show')
    },
    hideMenu (event) {
      event.preventDefault()
      $('.vuma-menu').removeClass('menu-show')
    },
    displayPages (product) {
      this.whichProduct = product
      this.showPages = true
    },
    scrollCoverage () {
      $('html, body').stop().animate({
        'scrollTop': $('.vm-coverage-wrap').offset().top - 50,
      }, 500, 'swing')
    },
    showApartment (value) {
      value === 'apartment'
        ? this.showingApartment = true
        : this.showingApartment = false
    },
    submitSMI () {
      this.$v.$touch()

      let vue = this

      if (!this.$v.$invalid) {
        vue.dialog = true
        let formData = {
          'name': this.form.name,
          'surname': this.form.surname,
          'email': this.form.email,
          'cell': this.form.cellphone,
          'updates': this.getUpdates,
          'marketing': this.marketingCheck,
          'champion': this.championCheck,
          'mdu_name': this.form.apartment,
          'mdu_unit': this.form.unit_number,
          'str_num': this.street_number || this.form.street_number,
          'str_name': this.street_name || this.form.street_name,
          'hood': this.suburb,
          'city': this.city,
          'postal': this.postal_code,
          'lat': parseFloat(this.lat),
          'lng': parseFloat(this.long),
          'place_id': this.place_id,
          'form_add': null,
          'channel': null,
        }

        this.axios.post('https://pangea.vumatel.co.za/orders/show_my_interest_requests/',
          formData,
          {
            headers: {
              'apikey': this.apiKey,
              'Content-Type': 'application/json',
            }
          }
        ).then(response => {
          if (response.status === 200) {
            vue.dialog = false
            vue.$router.push({
              name: 'SmiThankYou',
              params: {
                customerName: vue.form.name
              }
            })
          }
        })
      }
    },
    scrollToCoverage () {
      $('.move-to').on('click', function (e) {
        e.preventDefault()

        let target = '#' + $(this).data('section')
        let $target = $(target)

        $('html, body').stop().animate({
          'scrollTop': $target.offset().top - 70,
        }, 900, 'swing')
      })
    },
  },
}
</script>

<style lang="scss">
#vuma-interested {
  max-width: 850px !important;
  width: 100%;
}

.vm-coverage {
  .v-input .v-label {
    font-size: 22px;
    height: 45px;
  }

  .v-text-field input {
    line-height: 45px;
    max-height: 45px;
  }

  .vm-coverage-input {
    max-width: 650px;
    width: 100%;
    margin: 1rem auto 0;
  }
}

.coverage-results {
  position: relative;
  text-align: center;

  h2 {
    background: #FF008E;
    color: #fff;
    padding: 2rem;
  }

  h3 {
    margin-bottom: 1rem;
  }

  .addr-title {
    text-transform: capitalize;
    margin-bottom: 2rem;
  }

  .actual-addr {
    margin-bottom: 1rem;
  }

  p {
    font-size: 16px;
  }

  a.change-addr-btn {
    text-transform: uppercase;
    font-size: 14px !important;
  }

  .your-addr-wrap {
    margin-bottom: 2rem;
  }
}

.complex-heading-tab {
  .v-tabs-slider-wrapper {
    width: 100% !important;
  }

  .v-tab {
    width: 50%;
  }
}

.apartment-radio {
  .v-input--radio-group__input {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }

  .v-radio {
    border-radius: 2rem;
    border: 1px solid rgba(0, 0, 0, 0.87);
    padding: 0.5rem 1rem;

    &:hover {
      border-color: #ff008e;
    }

    .v-input--selection-controls__ripple {
      display: none;
    }
  }
}

.v-input--checkbox {
  a {
    color: #ff008e;
  }
}

.form-group {
  .error {
    display: none;
    text-align: left;
    background-color: transparent !important;
    color: #ff5252;
    font-size: 14px;
  }

  &.form-group--error .error {
    display: block;
  }
}

@media screen and (max-width: 520px) {
  .apartment-radio .v-radio {
    margin-top: 1rem;
  }
}
</style>